var map = {
	"./Britannia.svg": 515,
	"./Gard.svg": 516,
	"./Japan.svg": 517,
	"./North.svg": 518,
	"./NorthStandard.svg": 519,
	"./Shipowners.svg": 520,
	"./Skuld.svg": 521,
	"./StandardClub.svg": 522,
	"./SteamshipMutual.svg": 523,
	"./SteamshipMutual_V2.svg": 524,
	"./UkPIClub.svg": 525,
	"./WestOfEngland.svg": 526,
	"./theAmericanClub.svg": 527,
	"./theLondon.svg": 528,
	"./theSwedishClub.svg": 529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;